import { lazy } from 'react';

const Home = lazy(() => import(/* webpackChunkName: "responsive-home" */ './index.js'));

export default Home;
